import script from "./FacilitiesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilitiesView.vue?vue&type=script&setup=true&lang=js"

import "./FacilitiesView.vue?vue&type=style&index=0&id=a6139866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6139866"]])

export default __exports__